import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { ThemeBlueprint } from '@backstage/plugin-app-react';
import { UnifiedThemeProvider, themes } from '@backstage/theme';
import { CssBaseline } from '@material-ui/core';
import { customTheme } from '../theme/customTheme';

/**
 * Backstage built-in dark theme.
 */
const darkThemeExtension = ThemeBlueprint.make({
    name: 'dark',
    params: {
        theme: {
            id: 'dark',
            title: 'Dark',
            variant: 'dark',
            Provider: ({ children }) => (
                <UnifiedThemeProvider theme={themes.dark}>
                    {children}
                </UnifiedThemeProvider>
            ),
        },
    },
});

/**
 * Porsche / PDIG custom dark theme with branded colours and typeface.
 */
const pdigThemeExtension = ThemeBlueprint.make({
    name: 'pdig',
    params: {
        theme: {
            id: 'pdigTheme',
            title: 'Custom Theme',
            variant: 'dark',
            Provider: ({ children }) => (
                <UnifiedThemeProvider theme={customTheme}>
                    <CssBaseline />
                    {children}
                </UnifiedThemeProvider>
            ),
        },
    },
});

/**
 * Frontend module that registers the dark and custom PDIG themes as native New
 * Frontend System extensions, replacing the `themes` array previously passed to
 * `convertLegacyAppOptions`.
 */
export const themesModule = createFrontendModule({
    pluginId: 'app',
    extensions: [pdigThemeExtension, darkThemeExtension],
});

